var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('quote-form',{attrs:{"model":_vm.formModel,"rawModel":_vm.rawModel,"mode":"view"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }